import { Component, ImageFields, Nullable } from '@boss/types/b2b-b2c';

export const isInstanceOfImage = (entry: Nullable<Component>): entry is ImageFields => entry?.__typename === 'image';
